// Minimal RFC-4180 CSV parser (quoted fields, escaped quotes, CRLF).
export function parseCsv(text) {
  const rows = [];
  let row = [], cell = "", q = false;
  const s = text.replace(/^\uFEFF/, "");
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (q) {
      if (ch === '"' && s[i + 1] === '"') { cell += '"'; i++; }
      else if (ch === '"') q = false;
      else cell += ch;
    } else if (ch === '"') q = true;
    else if (ch === ",") { row.push(cell); cell = ""; }
    else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && s[i + 1] === "\n") i++;
      row.push(cell); rows.push(row); row = []; cell = "";
    } else cell += ch;
  }
  if (cell || row.length) { row.push(cell); rows.push(row); }
  return rows.filter(r => r.some(c => c.trim()));
}

const HEADERS = { name: ["name", "full name", "candidate name", "candidate"], email: ["email", "email address", "e-mail"], phone: ["phone", "phone number", "mobile", "contact"] };
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function candidatesFromCsv(text, existingEmails) {
  const rows = parseCsv(text);
  if (!rows.length) throw new Error("The file is empty");
  const head = rows[0].map(h => h.trim().toLowerCase());
  const col = Object.fromEntries(Object.entries(HEADERS).map(([k, names]) => [k, head.findIndex(h => names.includes(h))]));
  if (col.name < 0 || col.email < 0) throw new Error('The first row must have "name" and "email" columns');
  const seen = new Set();
  return rows.slice(1).map((r, i) => {
    const name = (r[col.name] || "").trim(), email = (r[col.email] || "").trim().toLowerCase();
    const phone = col.phone >= 0 ? (r[col.phone] || "").trim() : "";
    let issue = null, kind = "ok";
    if (!name) { issue = "Missing name"; kind = "error"; }
    else if (!EMAIL_RE.test(email)) { issue = "Invalid email"; kind = "error"; }
    else if (phone && !/^\+\d{7,15}$/.test(phone.replace(/[\s-]/g, ""))) { issue = "Phone must start with + and country code"; kind = "error"; }
    else if (existingEmails.has(email)) { issue = "Already in this job — will be skipped"; kind = "skip"; }
    else if (seen.has(email)) { issue = "Repeated in file — will be skipped"; kind = "skip"; }
    if (kind === "ok") seen.add(email);
    return { line: i + 2, name, email, phone: phone.replace(/[\s-]/g, ""), issue, kind };
  });
}

export const CSV_TEMPLATE = "name,email,phone\nJane Doe,jane@example.com,+14155550123\nRavi Kumar,ravi@example.com,\n";
